import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { getIsAbnLoyaltyProgramEnabled } from '~/src/features/domru-bonus/constants/abnVariants';
import { IHintProps } from '~/src/features/payments-abn/components/InfoHint';
import { EValidityStatus } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actionCreators';
import { TState } from '~/src/store';

import { useSbpHint } from './useSbpHint';


export const useLoyaltyHint = (): IHintProps | undefined => {
    const { paymentMethod, ticketPayment, availableBonuses } = useSelector((state: TState) => ({
        paymentMethod: state.payment.method?.methodType,
        ticketPayment: state.seasonTicketPayment,
        availableBonuses: state.loyalty.info.bonuses,
    }), shallowEqual);

    const isAbnProgramTermsEnabled = useMemo(getIsAbnLoyaltyProgramEnabled, []);

    const { bonusesInfo: { amount, validity }, seasonTicket } = ticketPayment;
    const { paySum = 0 } = seasonTicket || {};

    const { getSbpHintByBonusesPaymentResult } = useSbpHint();

    const requiredBonusesToPay = isAbnProgramTermsEnabled
        ? paySum / 0.2
        : paySum;

    const maxBonusesAmount = Math.min(availableBonuses, Math.floor(requiredBonusesToPay));

    switch (true) {
        case (amount === paySum):
            return;
        case (
            validity === EValidityStatus.IS_VALID &&
            amount < Math.ceil(paySum) &&
            paymentMethod === 'sbp'
        ):
            return getSbpHintByBonusesPaymentResult();
        case validity === EValidityStatus.IS_LOWER_BOUND_ERROR:
            return {
                hintType: 'error',
                hintMessage: `Невозможно списать 0 бонусов. Введите любое другое количество от 1 до ${maxBonusesAmount}. ` +
                    'Если не хотите списывать бонусы, просто уберите галочку.',
            };
        case validity === EValidityStatus.IS_UPPER_BOUND_ERROR: {
            const notMoreThanBonuses = ((maxBonusesAmount === 1 || maxBonusesAmount % 10 === 1) && maxBonusesAmount !== 11)
                ? 'бонуса'
                : 'бонусов';

            return {
                hintType: 'error',
                hintMessage: `Можно списать не больше ${maxBonusesAmount} ${notMoreThanBonuses}.`,
            };
        }
    }
};
